<template>

  <!-- <div class="pt-10 pb-10 pl-10 pr-10 rounded flex flex-wrap overflow-hidden"> -->
    <!-- <div class="w-1/3 overflow-hidden">
      <img class="lg:w-64 lg:h-64 " src="../assets/images/ID10.png"/>
    </div> -->

    <div class="container mx-auto p-5 sm:p-3 md:p-10 lg:p-20 text-center w-2/3 overflow-hidden pb-10">
      <h1 class="text-2xl sm:text-5xl md:text-5xl lg:text-6xl font-extrabold mb-2 text-gray-800">Jaaki<span class="text-orange-500">T</span></h1>
      <h3 class="text-xl sm:text-2xl md:text-3xl lg:text-lx4 mb-8 text-gray-700">Software Engineering & Web</h3>
      <router-link
        class="bg-black opacity-75 font-bold text-orange-500 hover:text-white rounded-full pt-3 pb-3 align-middle px-8 shadow-lg uppercase tracking-wider"
        to="/projects"
      >Projects</router-link>
    </div>

  <!-- </div> -->


</template>

<script>

export default {
  name: "Home",
  components: {
  }
};
</script>
